import React from "react";

const LTIAssignment = () => {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Welcome to the AI Generated LTI Assignment!</h1>
        </div>
    );
};

export default LTIAssignment;
